module.exports = __webpack_public_path__ + "static/media/campaignPdfThumbnail.9a2d7e8c.png";